import { render, staticRenderFns } from "./ConfigurationDivisions.vue?vue&type=template&id=71b682f2&scoped=true&"
import script from "./ConfigurationDivisions.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationDivisions.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationDivisions.vue?vue&type=style&index=0&id=71b682f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b682f2",
  null
  
)

export default component.exports